import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { TranslocoDirective } from '@jsverse/transloco';
import { NoResultsLabelComponent } from './no-results-label.component';

@NgModule({
  declarations: [NoResultsLabelComponent],
  imports: [CommonModule, TranslocoDirective],
  exports: [NoResultsLabelComponent],
})
export class NoResultsLabelModule {}
